import { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { FaBars, FaTimes } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import "./Navbar.css";

const MyNavbar = () => {
  const location = useLocation(); // Get the current URL path
  const [expanded, setExpanded] = useState(false);
  const [activeLink, setActiveLink] = useState(""); // Track active link

  useEffect(() => {
    // Set active link based on URL path
    setActiveLink(location.pathname);
  }, [location]);

  const handleNavClick = (link) => {
    setActiveLink(link); // Update active link state
    setExpanded(false); // Close mobile menu
  };

  return (
    <Navbar expand="md" className="navbar" expanded={expanded}>
      <Container>
        {/* Logo */}
        <Navbar.Brand href="#">
          <img src="./assets/Logo.webp" alt="Logo" />
        </Navbar.Brand>

        {/* Mobile Menu Button */}
        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? <FaTimes size={24} /> : <FaBars size={24} />}
        </Navbar.Toggle>

        {/* Navigation Links */}
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link
              href="/"
              className={activeLink === "/" ? "active" : ""}
              onClick={() => handleNavClick("/")}
            >
              Home
            </Nav.Link>
            <Nav.Link
              href="/products"
              className={activeLink === "/products" ? "active" : ""}
              onClick={() => handleNavClick("/products")}
            >
              Remecure Scar products
            </Nav.Link>
            <Nav.Link
              href="/buy"
              className={activeLink === "/buy" ? "active" : ""}
              onClick={() => handleNavClick("/buy")}
            >
              Where to Buy
            </Nav.Link>
            <Nav.Link
              href="/articles"
              className={activeLink === "/articles" ? "active" : ""}
              onClick={() => handleNavClick("/articles")}
            >
              Articles
            </Nav.Link>
            <Nav.Link
              href="/contact"
              className={activeLink === "/contact" ? "active" : ""}
              onClick={() => handleNavClick("/contact")}
            >
              Contact Us
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default MyNavbar;
